export const CHECKOUT_RETURN_FLAG = "chatshop_checkout_return_pending";